{
  "sizes": [
    {
      "key": "duel",
      "name": "Duel",
      "width": 40,
      "height": 26,
      "suggestedCivs": 3
    },
    {
      "key": "small",
      "name": "Small",
      "width": 60,
      "height": 38,
      "suggestedCivs": 5
    },
    {
      "key": "standard",
      "name": "Standard",
      "width": 80,
      "height": 50,
      "suggestedCivs": 7
    },
    {
      "key": "large",
      "name": "Large",
      "width": 110,
      "height": 70,
      "suggestedCivs": 9
    },
    {
      "key": "huge",
      "name": "Huge",
      "width": 140,
      "height": 90,
      "suggestedCivs": 11
    }
  ],
  "defaults": {
    "size": "standard",
    "wrapX": true,
    "_comment_land": "Shape of the world. seaLevel is a target water FRACTION, not a raw threshold — the generator finds whatever elevation hits it, so land area stays stable across seeds.",
    "seaLevel": 0.6,
    "continentScale": 4.5,
    "warpStrength": 4.5,
    "octaves": 5,
    "gain": 0.52,
    "polarRows": 2,
    "minIslandSize": 4,
    "_comment_plates": "Voronoi plates give continents a skeleton and put mountain ranges where plates collide. plateCount is the strongest control over how EVENLY land is spread: too few and several oceanic plates merge into one dead ocean with the land crowded elsewhere. plateSpread breaks up runs of same-type plates.",
    "tilesPerPlate": 167,
    "minPlates": 14,
    "oceanicPlateFraction": 0.5,
    "plateSpread": 1,
    "plateInfluence": 0.75,
    "boundaryUplift": 0.42,
    "riftDepth": 0.9,
    "boundaryWidth": 0.09,
    "plateWarp": 0.14,
    "_comment_relief": "Fractions of LAND tiles, not of the whole map.",
    "mountainFraction": 0.07,
    "hillFraction": 0.19,
    "_comment_water": "Enclosed water bodies up to maxLakeSize become lakes; anything larger stays an inland sea.",
    "maxLakeSize": 16,
    "_comment_climate": "Moisture is advected by prevailing winds and lost climbing terrain, which is what puts deserts in rain shadows instead of scattering them randomly.",
    "temperatureNoise": 0.1,
    "moisturePasses": 3,
    "evaporationRate": 0.3,
    "rainfallRate": 0.045,
    "orographicRate": 1.4,
    "desertMoisture": 0.2,
    "desertTemperature": 0.55,
    "grasslandMoisture": 0.5,
    "tundraTemperature": 0.24,
    "rainforestTemperature": 0.72,
    "_comment_features": "Densities scale the climate thresholds, so raising forestDensity widens the band of climates that grow forest.",
    "forestDensity": 0.3,
    "rainforestDensity": 0.22,
    "marshDensity": 0.05,
    "oasisChance": 0.04,
    "_comment_rivers": "Sources are chosen from wet highlands; a river is kept only if it reaches water and is at least minLength tiles long.",
    "riverDensity": 0.011,
    "riverMinLength": 4,
    "_comment_resources": "resourceDensity is the fraction of LAND TILES carrying a resource in total, shared out by class weight and rarity. minStrategic guarantees every strategic resource exists somewhere, so a map can never be unplayable.",
    "resourceDensity": 0.09,
    "resourceMinSpacing": 3,
    "minStrategicPerType": 4
  },
  "mapTypes": [
    {
      "key": "continents",
      "name": "Continents",
      "summary": "A few large landmasses divided by ocean.",
      "overrides": {}
    },
    {
      "key": "pangaea",
      "name": "Pangaea",
      "summary": "Most land joined in one great continent: neighbours meet early.",
      "overrides": {
        "seaLevel": 0.5,
        "continentScale": 2.6
      }
    },
    {
      "key": "archipelago",
      "name": "Archipelago",
      "summary": "Many islands: ships matter from the start.",
      "overrides": {
        "seaLevel": 0.67,
        "continentScale": 7.5
      }
    }
  ]
}
